import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import VirtualizedAppService from "../../src/Services/VirtualizedApp.service";
const VirtualizedAppLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<VirtualizedApp[]>' is not assignable to type '(ids: string[]) => Promise<VirtualizedApp[]>'.
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            return VirtualizedAppService.search({ ids });
        },
        fetchOptions: (search) => {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            return VirtualizedAppService.search({ query: search, external: false });
        },
        optionRenderer: function optionRenderer(virtualizedApp) {
            return _jsx("span", { children: virtualizedApp.displayName });
        },
    });
};
export default VirtualizedAppLookup;
